/*
 * recommendation.js
 *
 * Contains all recommendation data for client computers and servers.
 * These values can be easily edited without needing to understand the rest of the code.
 */
 
export const recommendationData = {
  client_min: {
    id: 1,
    name: "Basic Client Computer",
    cpu: "Intel Core i3-10105 with 3.7 GHz (4 Cores)",
    ram: "4-8 GB RAM",
    hdd: "256 GB SSD",
    nic: "Gigabit Ethernet",
    os: "Windows 11"
  },
  client_med: {
    id: 2,
    name: "Advanced Client Computer",
    cpu: "Intel Core i5-12500 with 3.2 GHz (6 Cores)",
    ram: "8-16 GB RAM",
    hdd: "256 GB SSD",
    nic: "Gigabit Ethernet",
    os: "Windows 11"
  },
  client_max: {
    id: 3,
    name: "High End Client Computer",
    cpu: "Intel Core i7-12700 with 2.9 GHz (12 Cores)",
    ram: "16 GB RAM",
    hdd: "512 GB SSD + 2 TB SATA III",
    nic: "Gigabit Ethernet",
    os: "Windows 11 PRO 64 bit "
  },
  server_M: {
    id: 5,
    name: "Basic Server",
    cpu: "Intel Xeon E-2314 with 2.8 GHz",
    ram: "16 GB RAM",
    hdd: "fast RAID storage + NAS or SAN",
    nic: "1GbE Broadcom 5720 DualPort",
    os: "Windows Server 2022 Standard incl. 5 CALs"
  },
  server_L: {
    id: 6,
    name: "Advanced Server",
    cpu: "Intel Xeon Silver 4309Y with 2.8 GHz (8 Cores)",
    ram: "32-64 GB RAM",
    hdd: "fast RAID storage + NAS or SAN",
    nic: "1GbE Broadcom 5719 QuadPort",
    os: "Windows Server 2022 Standard incl. 5 CALs"
  },
  server_XL: {
    id: 7,
    name: "High End Server",
    cpu: "2x Intel Xeon Silver 4310 with 2.10 GHz (12 Cores)",
    ram: "64-128 GB RAM",
    hdd: "fast RAID storage + NAS or SAN",
    nic: "1GbE Broadcom 5719 QuadPort",
    os: "Windows Server 2022 Standard incl. 5 CALs"
  }
};



// WEBPACK FOOTER //
// ./src/recommendation.js